// extracted by mini-css-extract-plugin
module.exports = {"comment_container":"comment_container-1b5b1vVx clearfix","comment_join":"comment_join-22e8Buvp","url_comment":"url_comment-3HlUlIb4"};